import React, {useRef} from "react";
import {observer} from "mobx-react";
import styled, {css} from "styled-components";
import {CardBox} from "../../../../basic-components/card/card.box";
import {
    IPaymentHandlerViewModel
} from "../../../../services/booking/models/payment/payment-handler.view-model.interface";
import {
    IPaymentMethodViewModel
} from "../../../../services/booking/models/payment/methods/payment-method.view-model.interface";
import {scrollElementIntoViewLazySmooth} from "../../../../utils/scroll-element-into-view";

const ContainerBox = styled.div<{$disabled: boolean}>`
    display: flex;
    flex-direction: column;
    color: ${props => props.theme.colors.dark};
    opacity: ${props => props.$disabled ? 0.4 : 1};
`

const HeaderBox = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    //align-items: stretch;
    padding-left: ${props => props.theme.spacing.spacing16};
    font-size: ${props => props.theme.fontSize.h4};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    overflow-x: auto;
    scrollbar-width: none;
    
    &::-webkit-scrollbar {
        display: none;
    }
    gap: 4px;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        padding-left: ${props => props.theme.spacing.spacing8};
    }
`

const HeaderItemBox = styled.div<{$isSelected: boolean; $isDisabled: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-top-left-radius: ${props => props.theme.border.defaultRadius};
    border-top-right-radius: ${props => props.theme.border.defaultRadius};
    border: 1px solid  ${props => props.theme.colors.lightShade};
    border-bottom: none;
    padding: 0 ${props => props.theme.spacing.spacing8};
    /*box-shadow: 0 34px 26px rgba(13, 10, 44, 0.05), 0 12px 60px rgba(13, 10, 44, 0.08);*/
    ${props => props.$isSelected
        ? css`
            background-color: ${props => props.theme.colors.cardBackground};
        `
        : css`
            background-color: ${props => props.theme.colors.lightShade};
        `
    }

    ${props => props.$isSelected || props.$isDisabled
            ? css`
                cursor: default;
            `   
            : css`
                cursor: pointer;
            `
    }

    ${props => props.theme.containerMediaQuery.smallScreen} {
        min-width: 70px;
    }
`

const ContentBox = styled(CardBox)`
    padding: ${props => props.theme.spacing.spacing24};
    border: none;
    min-height: 305px;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        padding: ${props => props.theme.spacing.spacing20} ${props => props.theme.spacing.spacing16};
        min-height: 345px;
    }
`

interface PaymentMethodTabHeaderItemComponentProps {
    paymentHandler: IPaymentHandlerViewModel;
    paymentMethod: IPaymentMethodViewModel;
}

const PaymentMethodTabHeaderItemComponent: React.FC<PaymentMethodTabHeaderItemComponentProps> = observer((props) => {
    const itemBoxRef = useRef<HTMLDivElement | null>(null);
    const paymentMethod = props.paymentMethod;
    const isDisabled = props.paymentHandler.paymentMethodsDisabled;
    const onClickHandler = () => {
        if(!isDisabled) {
            props.paymentHandler.selectPaymentMethod(paymentMethod.code)
            scrollElementIntoViewLazySmooth(itemBoxRef.current);
        }

    }
    return (
        <HeaderItemBox $isSelected={props.paymentHandler.getSelectedPaymentMethod()?.code === paymentMethod.code}
                       $isDisabled={isDisabled}
                       onClick={onClickHandler}
                       ref={itemBoxRef}>
            {paymentMethod.renderTabHeader()}
        </HeaderItemBox>
    )
});

interface PaymentMethodsTabsComponentProps {
    paymentHandler: IPaymentHandlerViewModel;

}

export const PaymentMethodsTabsComponent: React.FC<PaymentMethodsTabsComponentProps> = observer((props) => {


    const isDisabled = props.paymentHandler.paymentMethodsDisabled;
    const renderHeaderItem = (paymentMethod: IPaymentMethodViewModel) => {
        return (
            <PaymentMethodTabHeaderItemComponent key={paymentMethod.code} paymentHandler={props.paymentHandler} paymentMethod={paymentMethod}/>
        );
    }

    return (
        <ContainerBox $disabled={isDisabled}>
            <HeaderBox>
                {props.paymentHandler.allPaymentMethods.map(renderHeaderItem)}
            </HeaderBox>
            <ContentBox>
                {props.paymentHandler.getSelectedPaymentMethod()?.renderTabContent()}
            </ContentBox>
        </ContainerBox>
    );
})